export const locales = ['en', 'de'] as const
export type Locale = (typeof locales)[number]

export const defaultLocale: Locale = 'en'

export const isLocale = (x: string): x is Locale => {
  return (locales as readonly string[]).includes(x)
}
